import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnCode,
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnPublisher,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { fitToPage, goToCodePage } from '@/hooks/paging';
import CollectionDatasetsTableRows from './CollectionDatasetsTableRows';
import CollectionDatasetsTableHeader from './CollectionDatasetsTableHeader';
import DatasetsFilters from '../containers/CollectionDatasetsFilters';
import CollectionDatasetsTableSettingsMenu from '../containers/CollectionDatasetsTableSettingsMenu';

const CollectionDatasetsTable = ({
  code,
  datasets,
  readStatus,
  readErrors,
  category,
  total,
  pageCount,
  pageSize,
  currentPage,
  fetchData,
  canManage,
  className,
  hideColumns,
  onCheckBoxClick,
  showAddDataset,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnCode,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnPublisher,
    columnTools,
  ],
  theme,
}) => {
  const { items, pageNumber } = fitToPage(datasets, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className={clsx('ReactTable', className)} ref={ref}>
      <TableWrapper sticky celled className="aridhia-datasets-table" columns={columns}>
        <CollectionDatasetsTableHeader
          category={category}
          code={code}
          columns={columns}
          datasets={items}
          hideColumns={hideColumns}
          loaderButton={!hideColumns}
          readErrors={readErrors}
          readStatus={readStatus}
        >
          { readStatus === states.SUCCESS && !hideColumns && (
          <CollectionDatasetsTableSettingsMenu code={code} category={category} />
          )}
          <DatasetsFilters code={code} category={category} className="aridhia-table-filter" />
        </CollectionDatasetsTableHeader>
        <Table.Body>
          <CollectionDatasetsTableRows
            code={code}
            category={category}
            items={items}
            columns={columns}
            onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
            theme={theme}
          />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate={canManage}
        currentPage={pageNumber}
        entity="collection.datasets"
        goToPage={({ page }) => goToCodePage(fetchData, category, code, page, ref)}
        icon="table"
        items={items}
        onClick={() => showAddDataset(category, code)}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
    </div>
  );
};

export default CollectionDatasetsTable;
